import { WalletComponent } from "../wallet_apis/types";

export enum TransferStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
}

export enum KycStatus {
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
  REJECTED = "REJECTED",
  NOT_SUBMITTED = "NOT_SUBMITTED",
}

export interface FundTransferRequest {
  senderUserId: string;
  senderKycStatus: KycStatus;
  senderName?: string;
  receiverUserId: string;
  receiverKycStatus: KycStatus;
  receiverName?: string;
  component: WalletComponent;
  amount: number;
  remarks?: string;
  ipAddress?: string;
  deviceInfo?: {
    browser?: string;
    browserVersion?: string;
    os?: string;
    osVersion?: string;
    device?: string;
    userAgent?: string;
  };
}

export interface TransferResult {
  transferNumber: string;
  amountSent: number;
  adminCharges: number;
  netAmountReceived: number;
  senderNewBalance: number;
  receiver: {
    userId: string;
    name?: string;
  };
  status: TransferStatus;
}

export interface TransferResponse {
  id: string;
  transferNumber: string;
  senderUserId: string;
  senderRegisterId?: string;
  senderName?: string;
  receiverUserId: string;
  receiverName?: string;
  component: string;
  amount: number;
  adminChargesPercent: number;
  adminChargesAmount: number;
  netAmount: number;
  status: TransferStatus;
  remarks?: string;
  createdAt: string;
  receiverRegisterId: string;
}

export interface TransferHistoryResponse {
  transfers: TransferResponse[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface TransferStatistics {
  totalSent: number;
  totalSentTransactions: number;
  successSent: number;
  failedSent: number;
  totalReceived: number;
  totalReceivedTransactions: number;
  successReceived: number;
  failedReceived: number;
  netAmount: number;
}

export interface FundDropdownValue {
  component: WalletComponent;
  displayName: string;
  balance: number;
  isTransferable: boolean;
}

export interface TransferHistoryQuery {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  sortOrder?: "ASC" | "DESC";
}

export interface ReceiverInfo {
  userId: string;
  name: string;
}

export interface TransferState {
  dropdownValues: FundDropdownValue[];
  sentHistory: TransferResponse[];
  receivedHistory: TransferResponse[];
  pagination: TransferHistoryResponse["pagination"] | null;
  statistics: TransferStatistics | null;
  currentTransfer: TransferResponse | null;
  receiverInfo: ReceiverInfo | null;
  receiverLoading: boolean;
  receiverError: string | null;
  loading: boolean;
  error: string | null;
  success: boolean;
}
